module.exports = __webpack_public_path__ + "static/media/manzo_07_full.a803ecf1.jpg";